import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import ProductVariationsProp from '../../propTypes/productVariationsProp';

function PackVariation(props) {
  const { t, packVariation, stockManagementMessage, packQuantity } = props;
  const { variation, quantity } = packVariation || {};

  const { icon, name } = variation || {};

  const variationIcon = icon ? icon.thumb : '';

  return (
    <div className="product-info-item variation col-12">
      <div className="product-info-wrapper">
        <div className="product-info-image">
          <img src={variationIcon} alt={name} />
        </div>
        <div className="product-info-price">
          <div className="product-info-type correction-height">
            <span>{name}</span>
          </div>
        </div>
        <div className="product-info-packQuantity">
          {`${t('shop.product.qty')}: ${quantity}`}
        </div>
      </div>
      <div className="productRedTextInfo">
        <div>{stockManagementMessage(variation, packQuantity)}</div>
      </div>
    </div>
  );
}

PackVariation.propTypes = {
  t: PropTypes.func.isRequired,
  packVariation: PropTypes.shape(ProductVariationsProp.propType).isRequired,
  stockManagementMessage: PropTypes.func.isRequired,
  packQuantity: PropTypes.number.isRequired,
};

export default translate(PackVariation);
